import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "../lib/site";
import { useScrolledPast } from "../hooks/useScrolledPast";

export const WhatsAppFloat = () => {
  const show = useScrolledPast(600);

  return (
    <AnimatePresence>
      {show && (
        <motion.a
          href={WHATSAPP_URL()}
          target="_blank"
          rel="noreferrer"
          data-testid="whatsapp-float"
          initial={{ opacity: 0, scale: 0.6, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.6, y: 20 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-6 right-6 z-[65] grid place-items-center h-14 w-14 rounded-full bg-charcoal text-ivory btn-fill hover:text-charcoal transition-colors duration-500 hover:scale-105 transition-transform duration-300 shadow-[0_12px_40px_-8px_rgba(44,42,41,0.4)]"
          aria-label="Chat on WhatsApp"
        >
          <MessageCircle size={24} strokeWidth={1.6} />
        </motion.a>
      )}
    </AnimatePresence>
  );
};
